export const ExperimentsConsts = {
  EditorOOIFormPage: 'specs.bookings.EditorOOIFormPage',
  FormEditorKBContent: 'specs.bookings.FormEditorKBContent',
  MultiLocationUoU: 'specs.bookings.MultiLocationUoU',
  AddonsWithPlanOnlyUOU: 'specs.bookings.AddonsAndPlanOnlyUOU',
  CartConflictEnableSlotsTimezoneConversion:
    'specs.bookings.CartConflictEnableSlotsTimezoneConversion',
  UOUIntakeFormsIntegration: 'specs.bookings.UOUIntakeFormsIntegration',
  // Same Conductor experiment as bm-app/composer — gates all intake-form pending-approval
  // behaviour (login wall, pending card, pending booking-block). OFF ⇒ identical to pre-feature.
  IntakeFormsPendingApproval: 'intakeFormsPendingApproval',
  UseNewBenefitsAPIUoU: 'specs.bookings.UseNewBenefitsAPIUoU',
  ShowRemainingCourseSessions: 'specs.bookings.ShowRemainingCourseSessions',
  ShowUnavailableSlotForm: 'specs.bookings.ShowUnavailableSlotForm',
  ShowErrorMessageOnInvalidIntakeForm:
    'specs.bookings.showErrorMessageOnInvalidIntakeForm',
  TimezoneAwareSlotMatching: 'specs.bookings.TimezoneAwareSlotMatching',
  DepositeOrFullAmountUoU: 'specs.bookings.DepositeOrFullAmountUoU',
  AllDayMultiDayEvents: 'specs.bookings.AllDayMultiDayEvents',
  SubscriptionPricingUoU: 'specs.bookings.SubscriptionPricingUoU',
  SupportDynamicPricingWithPaymentOptions:
    'specs.bookings.SupportDynamicPricingWithPaymentOptions',
  RelatedProductsOnServices: 'specs.bookings.relatedProductsOnServices',
  BookingsFormWDS: 'specs.bookings.BookingsFormWDS',
  FormBfcacheStatusReset: 'formBfcacheStatus',
  BlockBuyPlanWhenNoAvailablePlansUoU: 'blockBuyPlanWhenNoAvailablePlansUoU',
  BookForSomeoneElse: 'bookForSomeoneElseUou',
  SupportDateAndNumOfParticipantsVariantsUoU:
    'supportDateAndNumOfParticipantsVariantsUoU',
  FixPayNowPriceForUsersWithPlans: 'fixPayNowPriceForUsersWithPlans',
  ShowSlotMoreDetailsOnMobile: 'showSlotMoreDetailsOnMobile',
};
